export const MonitoringForm =
{
    init: function ()
    {
        const vm = this;

        vm.initialized = false;
        vm.isEditable = false;
        vm.model = {};
        vm.files = {};
        vm.report = {};

        vm.reference = '';
        vm.status = '';

        vm.report_type = '';

        vm.new_report=false;
    }
}

export default MonitoringForm
